import { defineMessages } from "react-intl";
const messages = defineMessages({
    deletePolicySuccess: {
        id: "app.policies.policies.createPolicy.delete.success.text",
        defaultMessage: "Policy deleted successfully.",
    },
    deletePolicyTitle: {
        id: "app.policies.policies.createPolicy.delete.dialog.title.text",
        defaultMessage: "Delete policy",
    },
    deletePolicyDescription: {
        id: "app.policies.policies.createPolicy.delete.dialog.description.text",
        defaultMessage: "Are you sure you want to delete this policy? This will permanently delete the policy. Please, type delete to confirm.",
    },
    delete: {
        id: "app.policies.policies.createPolicy.delete.dialog.delete.button.text",
        defaultMessage: "Delete",
    },
});
export default messages;
